
import React from 'react'
import { useLocation } from 'react-router-dom';
import { SignUpGoogleAuthForm } from './sign-up-google-auth-form';
import PageLoader from '../../../../components/PageLoader';

export const GoogleAuthRegisterPage =() =>{
  
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
      };
	
    const query = useQuery();
    const x = query.get('x');
    const externalUserId = query.get('external-userid');
    const digitUserId = query.get('digiit-userid');
    const firstName = query.get('firstname');
    const lastName = query.get('lastname');
    const email = query.get('email');
    const tenantId = query.get('tenantid');
    const clientRedirectUrl = query.get('clientRedirectUrl');
    const miniToken = query.get('mini-token');
    // Access the query parameters
    const data = {
        'external-userid': externalUserId,
        'digiit-userid': digitUserId,
        'mini-token': miniToken,
        tenantid: tenantId,
        firstname: firstName,
        lastname: lastName,
        email: email
    }
   
    return (
        <>
            <div className='bg-gray-100 p-4'>
                {data ? <SignUpGoogleAuthForm data={data} /> : <PageLoader />}
            </div>
        </>
    )
}